import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "bg-white border border-gray-200 rounded-lg shadow-sm p-4" }
const _hoisted_2 = {
  key: 0,
  class: "flex justify-center items-center py-6"
}
const _hoisted_3 = {
  key: 1,
  class: "bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded mb-4"
}
const _hoisted_4 = { class: "block sm:inline" }
const _hoisted_5 = {
  key: 2,
  class: "text-center py-6 text-gray-500"
}
const _hoisted_6 = {
  key: 3,
  class: "space-y-4"
}
const _hoisted_7 = { class: "mb-6 bg-white rounded-lg shadow p-4" }
const _hoisted_8 = {
  key: 0,
  class: "bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded mb-4"
}
const _hoisted_9 = { class: "block sm:inline" }
const _hoisted_10 = { class: "flex gap-2" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 4,
  class: "fixed inset-0 bg-black/50 flex items-center justify-center z-50"
}
const _hoisted_15 = { class: "bg-white dark:bg-gray-800 rounded-lg shadow-lg w-full max-w-md p-6" }
const _hoisted_16 = { class: "flex justify-end space-x-3" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommentItem = _resolveComponent("CommentItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[12] || (_cache[12] = _createElementVNode("h4", { class: "text-base font-medium text-gray-700 mb-3" }, "Comments", -1)),
    (_ctx.loading && !_ctx.comments.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[6] || (_cache[6] = [
          _createElementVNode("div", { class: "animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary" }, null, -1)
        ])))
      : _createCommentVNode("", true),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _cache[7] || (_cache[7] = _createElementVNode("strong", { class: "font-bold" }, "Error:", -1)),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.error.message), 1),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.retryFetchComments && _ctx.retryFetchComments(...args))),
            class: "mt-2 px-3 py-1 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors"
          }, " Retry ")
        ]))
      : _createCommentVNode("", true),
    (!_ctx.loading && !_ctx.comments.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[8] || (_cache[8] = [
          _createElementVNode("p", null, "No comments yet. Be the first to comment!", -1)
        ])))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comments, (comment) => {
            return (_openBlock(), _createBlock(_component_CommentItem, {
              key: comment.id,
              comment: comment,
              isLoading: _ctx.loading,
              onEdit: _ctx.handleEdit,
              onDelete: _ctx.confirmDeleteComment
            }, null, 8, ["comment", "isLoading", "onEdit", "onDelete"]))
          }), 128))
        ])),
    _createElementVNode("div", _hoisted_7, [
      (_ctx.authError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _cache[9] || (_cache[9] = _createElementVNode("strong", { class: "font-bold" }, "Authentication Error:", -1)),
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.authError), 1),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.refreshAuth && _ctx.refreshAuth(...args))),
              class: "mt-2 px-3 py-1 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors"
            }, " Refresh Authentication ")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_10, [
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newComment) = $event)),
          class: "flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary resize-y min-h-[38px]",
          placeholder: "Add a comment...",
          rows: "1"
        }, null, 512), [
          [_vModelText, _ctx.newComment]
        ]),
        _createElementVNode("button", {
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addComment && _ctx.addComment(...args))),
          class: "px-4 py-2 bg-primary text-white rounded-md hover:bg-primary/90 transition-colors h-[38px] whitespace-nowrap",
          disabled: _ctx.loading || !_ctx.newComment.trim()
        }, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Sending..."))
            : (_openBlock(), _createElementBlock("span", _hoisted_13, "Send"))
        ], 8, _hoisted_11)
      ])
    ]),
    (_ctx.showDeleteModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _cache[10] || (_cache[10] = _createElementVNode("h3", { class: "text-lg font-medium mb-3 dark:text-white" }, "Confirm Delete", -1)),
            _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-gray-600 dark:text-gray-300 mb-6" }, " Are you sure you want to delete this comment? This action cannot be undone. ", -1)),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showDeleteModal = false)),
                class: "px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
              }, " Cancel "),
              _createElementVNode("button", {
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.deleteSelectedComment && _ctx.deleteSelectedComment(...args))),
                class: "px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors",
                disabled: _ctx.loading
              }, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Deleting..."))
                  : (_openBlock(), _createElementBlock("span", _hoisted_19, "Delete"))
              ], 8, _hoisted_17)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}